import { useLocation } from '@reach/router';
import { SearchCategory, TypeOfSearch } from '../types/enums';
import { UseBuildInfo } from './useBuildInfo';
import { useSearch } from './useSearch';

export const useSeoPropertyData = () => {
  const location = useLocation();
  const buildInfo = UseBuildInfo();
  const searchParams = new URLSearchParams(location.search);
  const category = searchParams.get('category') ?? SearchCategory.Resale;
  const type = searchParams.get('type') ?? TypeOfSearch.Residential;

  const { seoData, canonical } = useSearch({
    seoOnly: true,
    queryString: location.search,
    overrideValues: { category, type },
    activeView: 'list',
    lastBuild: buildInfo?.lastBuild,
    searchFirstRunDefault: location?.state?.searchFirstRunDefault,
  });

  return { seoData, canonical };
};
